import React, { FC } from 'react';
import { BaseHeader } from './BaseHeader';

export const OneRowHeader: FC = ({ children }) => (
  <BaseHeader className="l-header--sign-in">{children}</BaseHeader>
);
